<div class="flex flex-col gap-4" (click)="$event.stopPropagation()">
  @if (enableCustomInput) {
    <div class="flex w-full gap-2">
      <mat-form-field subscriptSizing="dynamic" class="w-full">
        <mat-label>Custom Colour</mat-label>
        <input
          matInput
          placeholder="Enter hex colour"
          [formControl]="customColourCtrl"
          (input)="onCustomColourInput()"
          (blur)="onCustomColourInput()"
        />
        <button
          #pickerMenuTrigger="matMenuTrigger"
          matSuffix
          mat-icon-button
          matTooltip="Open colour picker"
          aria-label="Open colour picker"
          [matMenuTriggerFor]="pickerMenu"
        >
          <mat-icon class="icon-md">palette</mat-icon>
        </button>
        <mat-hint>Enter a hex colour</mat-hint>
      </mat-form-field>
      @if (displayCompactPreviewColour()) {
        <div class="flex h-11 w-6 items-center justify-center">
          <div
            class="checkerboard relative h-6 w-6 rounded-full"
            matTooltip="Selected Colour"
          >
            <div
              class="absolute left-0 top-0 h-full w-full rounded-full"
              [style.backgroundColor]="hexColour$ | async"
              [class.borderForWhite]="hexColour$ | async | map: isWhite : this"
              (click)="pickerMenuTrigger.openMenu()"
            ></div>
          </div>
        </div>
      }
    </div>

    <mat-menu #pickerMenu="matMenu">
      <div class="p-2" (click)="$event.stopPropagation()">
        <pt-colour-picker format="hex" [formControl]="customColourCtrl" />
      </div>
    </mat-menu>
  }

  @if (displayPreviewColour()) {
    <div class="checkerboard relative h-6 w-full rounded-sm">
      <div
        class="absolute left-0 top-0 h-full w-full rounded-sm"
        [style.backgroundColor]="hexColour$ | async"
        [class.borderForWhite]="colour | map: isWhite : this"
      ></div>
    </div>
  }

  <div *ngrxLet="palette$ as palette" class="grid grid-cols-6 gap-1">
    @for (colour of palette; track colour) {
      <div
        class="h-6 w-6 cursor-pointer rounded-sm"
        [style.backgroundColor]="colour"
        [class.borderForWhite]="colour | map: isWhite : this"
        (click)="selectColour(colour, $event)"
      ></div>
    }
  </div>

  @if (disableOpacity === false) {
    <div class="flex flex-col">
      <div class="mat-caption flex items-center justify-between opacity-70">
        <span>Opacity:</span>
        <span>
          {{ opacityCtrl.value | map: formatPercentage : this }}
        </span>
      </div>

      <mat-slider step="0.01" [min]="opacityMin" [max]="opacityMax">
        <input matSliderThumb [formControl]="opacityCtrl" />
      </mat-slider>
    </div>
  }
</div>
